<template>
    <EditPanel 
        ref="edit-panel"
        :title="panelTitle"
        :saving="loading"
        :autoSize="true"
        @save="editPanelSaveHandler" 
    >
        <div class="favourites-list-panel">
            <div class="form">
                <div class="form__section">
                    <div class="form__fields">
                        <div class="form__field-row">
                            <SmrInput
                                ref="name-input-el"
                                :value="data.name"
                                placeholder="Listenname"
                                :clearable="true"
                                :maxlength="50"
                                :error="isNameEmpty && this.submitted"
                                @change="fieldChangeHandler($event, 'name')">
                            </SmrInput>
                        </div>
                        <div class="form__field-row">
                            <SmrInput
                                :value="data.note"
                                inputType="textarea"
                                placeholder="Notiz"
                                :maxlength="255"
                                @change="fieldChangeHandler($event, 'note')">
                            </SmrInput>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </EditPanel>
</template>

<script>
import eventBus from '@/utils/event-bus';
import EditPanel from '@/components/EditPanel.vue'
import SmrInput from '@/components/form/SmrInput.vue'
// import Icon from '@/components/Icon.vue'

export default {
    components: {
        EditPanel,
        SmrInput,
        // Icon,
    },
    data() {
        return {
            loading: false,
            submitted: false,
            listId: false,
            data: {
                name: '',
                note: '',
                favorites: [],
            },
        }
    },
    computed: {
        panelTitle() {
            return this.listId ? 'Liste bearbeiten' : 'Neue Liste erstellen'
        },
        isNameEmpty() {
            return this.data.name === '' || this.data.name.length > 50
        },
    },
    mounted() {
        this.addListeners()
    },
    beforeDestroy() {
        this.removeListeners()
    },
    methods: {
        showFavouritesListPanelHandler(data) {
            this.prepareData(data)
            this.showDialog();
            if(this.data.name === '') {
                setTimeout(() => {
                    this.focusNameInput()
                }, 100);
            }
        },
        editPanelSaveHandler() {
            this.submitted = true
            if(this.listId) {
                this.saveList()
            } else {
                this.addList()
            }
        },
        fieldChangeHandler(output, dataKey) {
            this.data[dataKey] = output;
        },
        favouritesListChanged() {
            this.loading = false
            this.closeDialog()
        },
        addListeners() {
            eventBus.$on('showFavouritesListPanel', this.showFavouritesListPanelHandler);
        },
        removeListeners() {
            eventBus.$off('showFavouritesListPanel', this.showFavouritesListPanelHandler);
        },
        showDialog() {
            this.$refs['edit-panel'].showDialog();
        },
        closeDialog() {
            this.$refs['edit-panel'].closeDialog();
        },
        focusNameInput() {
            if(this.$refs['name-input-el']) {
                this.$refs['name-input-el'].focus()
            }
        },
        prepareData(data = {}) {
            this.submitted = false
            this.listId = data.id ?? false
            this.data.name = data.name ?? ''
            this.data.note = data.note ?? ''
            this.data.favorites = data.favorites ?? []
        },
        addList() {
            if(!this.isNameEmpty) {
                this.loading = true
                this.$store.dispatch('addFavouritesList', this.data)
                this.favouritesListChanged()
            }
        },
        async saveList() {
            if(!this.isNameEmpty) {
                this.loading = true
                await this.$store.dispatch('editFavouritesList', {...this.data, id: this.listId})
                this.favouritesListChanged()
            }
        }
    }
}
</script>

<style lang="scss">

</style>